import { ColumnDef } from '@tanstack/react-table';
import { formatPrice } from 'utils/formatters';

import { CopyId } from 'components/ui/copy-id';
import { Timestamp } from 'components/ui/timestamp';

import { TransactionItem } from './hooks/useDrawdownTransactions';

export const columns: ColumnDef<TransactionItem>[] = [
  {
    accessorKey: 'createdAt',
    header: 'Date',
    cell: ({ getValue }) => <Timestamp date={getValue<string>()} />,
  },
  {
    accessorKey: 'description',
    header: 'Description',
    cell: ({ getValue }) => getValue<string>() || '—',
  },
  {
    accessorKey: 'amount',
    header: 'Amount',
    cell: ({ getValue }) => {
      const { amountSubunits, currencyCode } = getValue<TransactionItem['amount']>();
      const formatted = formatPrice(Math.abs(amountSubunits) / 100, currencyCode);

      if (amountSubunits === 0) {
        return <span>{formatted}</span>;
      }

      const isCredit = amountSubunits > 0;

      return (
        <span className={isCredit ? 'text-green-500' : 'text-red-500'}>
          {isCredit ? '+' : '-'}
          {formatted}
        </span>
      );
    },
  },
  {
    accessorKey: 'id',
    header: 'Transaction ID',
    meta: { cellClassName: 'whitespace-nowrap' },
    cell: ({ getValue }) => (
      <CopyId value={getValue<string>()} truncateAt={Number.POSITIVE_INFINITY} />
    ),
  },
];
